import webappTypes from "@assets/images/efficient-web-app-with-role-based-access.avif";

export const data = {

    heading: "Types of Web Applications",

    altText:'Efficient web app with role based access',
 
    list: [
        { boldText: 'Static Web Applications', text: 'These deliver consistent content to every user through pre-rendered HTML files, providing incredible loading speeds and simple hosting requirements. ' },
        { boldText: 'Dynamic Web Applications', text: 'These utilize server-side processing to generate real-time content, allowing for personalized user experiences and database interactions.' },
        { boldText: 'Single-Page Applications (SPAs)', text: 'These load a single HTML page and dynamically update content as the user interacts, resulting in smooth navigation and an app-like feel.' },
        { boldText: 'Multi-Page Applications (MPAs)', text: 'These follow traditional web structures where every change in data or view requires a new page load, making them ideal for large, SEO-heavy sites.' },
        { boldText: 'Progressive Web Applications (PWAs)', text: 'These leverage modern browser capabilities to provide offline access, push notifications, and home screen installation without an app store.' },
        { boldText: 'E-commerce Web Applications', text: 'These are engineered to handle secure transactions, inventory management, and delicate customer journeys with high-converting checkout flows.' },
       
    ],
        img: webappTypes,
    
    

}